import React from "react";
import { StyledWhiteContainer } from "features/metadesk/settings/common.styles";
import CodeSnippet from "../../components/CodeSnippet";
import { useIntl } from "react-intl";

import ApiKey from "../../components/ApiKey";
import axios from "axios";
import { useOutletContext } from "react-router";
import { apiUrl } from "features/configure";
import useDispatchSnackbar from "hooks/useDispatchSnackbar";
import {
  generateWebsiteOptInScript,
  websiteOptInTrackingAddressCode,
} from "features/configure/appCode";
import { selectWebsiteOptInVersionCanUpdate } from "features/metadesk/redux/entityConfig/entityConfig.selector";
import { useSelector } from "react-redux";

export default function Code({ data, integrityInfo, handleRefetch }) {
  const { formatMessage } = useIntl();
  const [entityName] = useOutletContext();
  const dispatchSnackbar = useDispatchSnackbar();
  const { latestVersion } = useSelector(selectWebsiteOptInVersionCanUpdate);
  const handleRegenerateAPI = async () => {
    try {
      const response = await axios.post(
        `${apiUrl}/api/manage/apiKey/${entityName}/websiteOptIn`,
        {
          websiteOptInId: data?._id,
        }
      );
      await handleRefetch();
      dispatchSnackbar({
        message: formatMessage({
          id: "global.snackbar.success.regenerateApiKey",
        }),
        variant: "success",
      });
    } catch (err) {
      console.log(err);
      // dispatchSnackbar({ err });
    }
  };
  return (
    <div className="fade-up-more">
      <StyledWhiteContainer style={{ margin: "12px 0" }}>
        <ApiKey
          apiKey={data.apiKey}
          apiKeyCreated={data.created}
          handleRegenerate={handleRegenerateAPI}
        />
      </StyledWhiteContainer>

      <StyledWhiteContainer style={{ margin: "12px 0" }}>
        <CodeSnippet
          title={formatMessage({
            id: "notification.subscribeBtn.snippetTitle",
          })}
          describe={formatMessage(
            {
              id: "notification.subscribeBtn.snippetDesc",
            },
            {
              br: <br />,
            }
          )}
          instruction={formatMessage({
            id: "notification.subscribeBtn.snippetDesc",
          })}
          demoImage={"websiteOptInScriptDemo.png"}
          generateScript={generateWebsiteOptInScript}
          data={data}
          integrityInfo={integrityInfo}
          latestVersion={latestVersion}
          walletDetectCode={websiteOptInTrackingAddressCode}
          updateType="websiteOptIn"
        />
      </StyledWhiteContainer>
    </div>
  );
}
